import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const LinkNoDecoration = styled(Link)({
  textDecoration: 'none',
});
